<template>
  <div
    class="mega-menu"
    @mouseenter="$emit('mouseenter')"
    @mouseleave="$emit('mouseleave')"
  >
    <div class="mega-menu-content">
      <div
        v-for="(category, index) in categories"
        :key="index"
        class="category-column"
      >
        <router-link
          class="category-title"
          :to="{
            name: 'ProductListPage',
            params: { itemType: category.category.toLowerCase() },
          }"
        >
          {{ category.category }}
        </router-link>
        <ul>
          <li v-for="item in category.sub_categories" :key="item">
            <router-link
              :to="{
                name: 'ProductListPage',
                params: { itemType: category.category.toLowerCase() },
                query: { search: item },
              }"
            >
              {{ item }}
            </router-link>
          </li>
        </ul>
      </div>
      <div
        class="additional-categories category-column"
        v-if="additionalCategories?.length"
      >
        <ul>
          <li v-for="item in additionalCategories" :key="item.name">
            <router-link :to="item.link" class="category-title">
              {{ item.name }}
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MegaMenu",
  props: {
    categories: {
      type: Array,
      required: true,
    },
    additionalCategories: {
      type: Array,
      required: true,
    },
  },
  mounted() {},
  watch: {},
  emits: ["mouseenter", "mouseleave"],
};
</script>

<style lang="scss" scoped>
.mega-menu {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: #151522;
  z-index: 1000;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border-top: 1px solid #191919;
}

.mega-menu-content {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  max-width: 1300px;
  margin: 0 auto;
  padding: 21px 10px 7px 10px;
}

.category-column {
  flex: 0 1 200px;
  padding: 0 30px;
  border-right: 1px solid rgba(255, 255, 255, 0.1);
  margin-bottom: 20px;

  &:last-child {
    border-right: none;
  }

  .category-title {
    color: #15ca5c;
    font-size: 14px;
    font-weight: 700;
    margin-bottom: 15px;
    text-transform: uppercase;
  }

  &:not(.additional-categories) ul {
    margin-top: 20px;
  }

  ul {
    list-style-type: none;
    padding: 0;
    column-count: 2;
    column-gap: 35px;

    li {
      margin-bottom: 10px;

      a {
        color: #ffffff;
        font-size: 14px;
        text-decoration: none;
        transition: color 0.3s ease;
        text-wrap: nowrap;

        &:hover {
          color: #15ca5c;
        }
      }
    }
  }
}

.additional-categories {
  ul {
    display: flex;
    flex-direction: column;
  }

  ul li a {
    color: #15ca5c;
    text-transform: uppercase;
  }

  // flex-basis: 100%;
  // margin-top: 20px;
  // padding-top: 20px;
  // border-top: 1px solid rgba(255, 255, 255, 0.1);

  // ul {
  //     display: flex;
  //     flex-wrap: wrap;
  //     justify-content: flex-start;
  //     gap: 20px;
  //     list-style-type: none;
  //     padding: 0;

  //     li {
  //         a {
  //             color: #FFFFFF;
  //             font-size: 14px;
  //             text-decoration: none;
  //             text-transform: uppercase;
  //             transition: color 0.3s ease;

  //             &:hover {
  //                 color: #15CA5C;
  //             }
  //         }
  //     }
  // }
}

@media (max-width: 768px) {
  .mega-menu-content {
    flex-direction: column;
  }

  .category-column {
    flex-direction: row;
    border-right: none;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    padding-bottom: 20px;
    flex: auto;

    ul {
      column-count: 3;
    }
  }

  .additional-categories ul {
    column-count: 3;
    flex-direction: column;
    gap: 10px;
  }
}
</style>
